/** @format */

module.exports = {
  publicKey: "AB243986EA6900962FA49BCD6E5B5FF1",
  hostnameId: "casumo-de",
};



// WEBPACK FOOTER //
// ./src/partners/config/partner.js